import { config } from '../../utils/config';
import { identityAuth } from '../../auth/IdentityAuth';

// Shared HTTP plumbing for direct calls to the Identity-Api (the super-admin
// user-management surface). Every route is bearer-guarded; the backend enforces
// the actual rules, the UI mirrors them only for affordance.

export const identityBaseUrl = () => {
  const url = config.IDENTITY_API_URL;
  if (!url) {
    throw new Error(
      'Identity API URL is not configured. Set REACT_APP_IDENTITY_API_URL (or REACT_APP_API_URL) in your environment.'
    );
  }
  return url.replace(/\/$/, '');
};

export const authHeaders = async () => {
  const token = await identityAuth.getValidToken();
  if (!token) {
    throw new Error('You must be signed in to perform this action.');
  }
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

// Resolves the response, throwing the backend's own error message on failure so
// callers can surface it verbatim. A 409 keeps its status on the thrown error so
// duplicate-email flows can special-case it.
export async function handle(res) {
  if (res.status === 204) return null;
  const text = await res.text();
  let body = null;
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = { message: text };
    }
  }
  if (!res.ok) {
    const message =
      body?.errors?.[0]?.description ||
      body?.detail ||
      body?.title ||
      body?.message ||
      `Request failed (${res.status})`;
    const error = new Error(message);
    error.status = res.status;
    error.body = body;
    throw error;
  }
  return body;
}
